__turbopack_context__.v({
  "arrow": "StatesContainer-module-scss-module__0jZTQG__arrow",
  "header": "StatesContainer-module-scss-module__0jZTQG__header",
  "pill": "StatesContainer-module-scss-module__0jZTQG__pill",
  "root": "StatesContainer-module-scss-module__0jZTQG__root",
  "row": "StatesContainer-module-scss-module__0jZTQG__row",
  "scroller": "StatesContainer-module-scss-module__0jZTQG__scroller",
});
